import { useState, useEffect } from "react";
import Footer from "./Footer";
import Header from "./Header";
import Sidebar from "./Sidebar";
import SidebarIcons from "./SidebarIcons";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import { BOOKING_HISTORY, DOOR_INSPECTION_API } from "../api/apiPath";
import http from "../api/server";
import Iframe from "react-iframe";
import Toaster from "./common/Toaster";

export default function BookingHistory() {
  const [open, setOpen] = useState(true);
  const { inspectionMasterId, propertyMasterId } = useParams();
  const [hideSidebar, setHideSidebar] = useState(true);
  const { userObj } = useSelector((state) => state.user);

  const [showLoader, setShowLoader] = useState(false);
  const [pdfUrl, setPdfUrl] = useState(null);
  const [showPdfModal, setShowPdfModal] = useState(false);

  const isMobile = /Mobi|Android|iPhone|iPad|iPod/i.test(navigator.userAgent);

  const [steps, setSteps] = useState([]);
  const [loading, setLoading] = useState(false);

  const [toastData, setToastData] = useState({
    toastShow: false,
    toastType: "",
    toastString: "",
  });
  const closeButton = () => {
    setToastData({
      toastShow: false,
      toastData: "",
      toastType: "",
    });
  };

  const handleDownloadClick = async (propertyMasterId) => {
    setShowLoader(true);
    try {
      const response = await http.get(DOOR_INSPECTION_API, {
        params: {
          propertyId: propertyMasterId,
        },
        responseType: "blob",
      });

      const file = new Blob([response.data], { type: "application/pdf" });
      const fileURL = URL.createObjectURL(file);

      setPdfUrl(fileURL);
      if (isMobile) {
        const link = document.createElement("a");
        link.href = fileURL;
        link.download = `${propertyMasterId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
      } else {
        setShowPdfModal(true);
      }
    } catch (err) {
      console.error("Error while downloading ", err);
      console.log(
        "Something went wrong while downloading, please try again after sometime"
      );
      setToastData({
        toastShow: true,
        toastType: "failure",
        toastString:
          err.message ||
          "Something went wrong while downloading, please try again after sometime",
      });
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    const fetchBookingHistory = async () => {
      try {
        setLoading(true);

        const { data } = await http.get(BOOKING_HISTORY, {
          params: {
            clientId: userObj?.clientId,
            inspectionReferenceNumber: inspectionMasterId,
          },
        });
        const getIcon = (eventType) => {
          switch (eventType) {
            case "Inspection Started":
              return "fa-solid fa-magnifying-glass";
            case "Inspection Created":
              return "fa-solid fa-clipboard-check";
            case "Property Onboarded":
              return "fa-solid fa-magnifying-glass";
            case "Resubmission date":
              return "fa-solid fa-calendar-days";
            case "Submitted For Approval":
              return "fa-solid fa-location-arrow fa-rotate-270";
            case "Approved":
              return "fa-solid fa-circle-check";
            case "Rejected":
              return "fa-solid fa-xmark";
            default:
              return "fa-solid fa-circle-info";
          }
        };
        const formattedSteps = data?.map((item) => ({
          icon: getIcon(item.eventType || item.status),
          title: item.eventType || item.status || item.title,
          date: item.eventDate || item.actionDate,
          boxText: item.performedBy
            ? `${item.eventType} by - ${item.performedBy}`
            : item.comments || item.boxText || item.status,
          highlight: item.highlight || false,
        }));

        setSteps(formattedSteps || []);
      } catch (err) {
        console.error("Error generating QR:", err);
        console.log("Something went wrong while generating QR Codes");
        setToastData({
          toastShow: true,
          toastType: "failure",
          toastString: err.message || "Unknown error occurred",
        });
      } finally {
        setLoading(false);
      }
    };

    fetchBookingHistory();
  }, [userObj?.clientId, inspectionMasterId]);

  return (
    <>
      <Header hideSidebar={hideSidebar} setHideSidebar={setHideSidebar} />

      {userObj && (
        <div className="dashboard_body_main vh-100">
          <Toaster
            show={toastData.toastShow}
            toastType={toastData.toastType}
            title={toastData.toastString}
            theme={"dark"}
            position="top-center"
            closeButton={closeButton}
          />
          {hideSidebar ? (
            <Sidebar
              setHideSidebar={setHideSidebar}
              hideSidebar={hideSidebar}
            />
          ) : (
            <SidebarIcons />
          )}

          <div className="d-flex dashboard_body flex-column py-1  w-100 mt-2">
            <div className="booking-history-container mt-1 px-4">
              {/* Header */}
              <h1 className="page-title">Booking History</h1>

              <div className="step-right">
                <div className="step-header" onClick={() => setOpen(!open)}>
                  <p>
                    <i className="bi bi-house step-icon"></i>
                    <strong>
                      {steps[0]?.title} - {steps[0]?.date}
                    </strong>
                  </p>
                  <i
                    className={`bi ${
                      open ? "bi-chevron-up" : "bi-chevron-down"
                    }`}
                  ></i>
                </div>
                {open && (
                  <div className="step-details">
                    Details: Property was successfully added to the system. All
                    initial information was verified and confirmed.
                  </div>
                )}
              </div>

              {/* Unique ID + Report */}
              <div className="detailchek mt-5 mb-3">
                <p className="mt-3">
                  <strong>Unique ID: {inspectionMasterId}</strong>
                </p>

                <div className="download-container">
                  {showLoader ? (
                    <div className="loader"></div>
                  ) : (
                    <button
                      className="download-btn"
                      onClick={() => {
                        handleDownloadClick(propertyMasterId);
                      }}
                    >
                      <i className="bi bi-download me-2"></i> Download Report
                    </button>
                  )}
                </div>

                {/* Timeline */}
                <div className="timeline">
                  {loading ? (
                    <p>Loading timeline...</p>
                  ) : steps.length > 0 ? (
                    steps.map((step, index) => (
                      <div className="timeline-item-row" key={index}>
                        {/* LEFT SIDE: icon + title + date */}
                        <div className="timeline-left">
                          <div className="timeline-icon">
                            {step.icon === "dot" ? (
                              <div className="dot"></div>
                            ) : (
                              <i className={step.icon}></i>
                            )}
                          </div>
                          <div className="timeline-info">
                            <div
                              className={`inspection-title-after ${
                                step.highlight ? "text-danger fw-semibold" : ""
                              }`}
                            >
                              {step.title}
                            </div>
                            <div className="inspection-date">{step.date}</div>
                          </div>
                        </div>

                        {/* RIGHT SIDE: box */}
                        <div className="inspection-box">
                          <span>{step.boxText}</span>
                          <span className="dropdown-arrow">▼</span>
                        </div>
                      </div>
                    ))
                  ) : (
                    <p>No booking history found.</p>
                  )}
                </div>
              </div>
            </div>
          </div>
          <Footer />
        </div>
      )}
      {showPdfModal && pdfUrl && (
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            height: "100vh",
            width: "100vw",
            backgroundColor: "rgba(0, 0, 0, 0.6)",
            zIndex: 1050,
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
          }}
        >
          <div
            style={{
              width: "90%",
              maxHeight: "80vh",
              backgroundColor: "#fff",
              borderRadius: "8px",
              overflow: "hidden",
              display: "flex",
              flexDirection: "column",
            }}
          >
            <div
              style={{
                padding: "10px 15px",
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
              }}
            >
              <h5 className="modal-title mb-0">PDF Preview</h5>
              <button
                type="button"
                className="btn-close"
                onClick={() => {
                  setShowPdfModal(false);
                  setPdfUrl(null);
                }}
              ></button>
            </div>
            <div style={{ height: "90vh", padding: 0 }}>
              <Iframe
                src={pdfUrl}
                width="100%"
                height="100%"
                title="PDF Preview"
                style={{
                  border: "none",
                  display: "block",
                  width: "100%",
                  height: "100%",
                }}
                frameBorder="0"
              ></Iframe>
            </div>
          </div>
        </div>
      )}
    </>
  );
}
